import PropTypes from 'prop-types';
import React from 'react';
import { hoursType } from '@types/index';
import MuseumHours from '@components/MuseumHours';
import DropNavigationList from './DropNavigationList';
import HeaderStaticNavigationList from './HeaderStaticNavigationList';

const DesktopNavigation = ({ data, hours }) => {
  const classNames = {
    drop: 'flex-nowrap',
    toggle: '',
    nav: 'd-none d-md-flex',
    menu: 'py-2',
    wrapper: 'd-none d-md-flex flex-nowrap',
  };

  return (
    <div className="nav-container">
      <DropNavigationList
        itemData={data}
        classNames={classNames}
        isNavbar
      />
      <MuseumHours hours={hours} isMobileNav={false} />
      <HeaderStaticNavigationList itemData={data} />
    </div>
  );
};

const dataType = PropTypes.shape({
  type: PropTypes.string.isRequired,
});

DesktopNavigation.defaultProps = {
  hours: null,
};

DesktopNavigation.propTypes = {
  data: PropTypes.arrayOf(dataType).isRequired,
  hours: hoursType,
};

export default DesktopNavigation;
